export const BUTTON_CLASS = {
  BASE: 'rounded-full flex items-center justify-center px-4 sm:px-5 py-2 sm:py-3 font-semibold text-xs sm:text-sm transition-colors border gap-4',

  SECONDARY: 'bg-primary-50 text-primary-500 border-primary-500',
  PRIMARY: 'bg-primary-500 text-white border-primary-500',
  DANGER: 'bg-danger-500 text-white border-danger-500',
  SECONDARY_DANGER: 'bg-danger-50 text-danger-500 border-danger-500',
  SUCCESS:
    'bg-secondaryGreen-50 text-secondaryGreen-500 border-secondaryGreen-500',
  GRAYSCALE: 'bg-neutral-30 text-neutral-80 border-neutral-30 font-normal',
  TRANSPARENT: 'text-primary-500 font-semibold border-transparent',
  TRANSPARENT_DISABLED: 'text-neutral-70 border-none',
  DISABLED: 'bg-neutral-50 text-neutral-70 border-neutral-50',
};

export enum ButtonVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Danger = 'Danger',
  SecondaryDanger = 'SecondaryDanger',
  Success = 'Success',
  Grayscale = 'Grayscale',
  Transparent = 'Transparent',
}

export const getButtonStyleClass = (
  variant: ButtonVariant,
  disabled: boolean,
) => {
  if (disabled && variant === ButtonVariant.Transparent)
    return BUTTON_CLASS.TRANSPARENT_DISABLED;
  if (disabled) return BUTTON_CLASS.DISABLED;

  switch (variant) {
    case ButtonVariant.Success:
      return BUTTON_CLASS.SUCCESS;
    case ButtonVariant.Primary:
      return BUTTON_CLASS.PRIMARY;
    case ButtonVariant.Secondary:
      return BUTTON_CLASS.SECONDARY;
    case ButtonVariant.Danger:
      return BUTTON_CLASS.DANGER;
    case ButtonVariant.SecondaryDanger:
      return BUTTON_CLASS.SECONDARY_DANGER;
    case ButtonVariant.Grayscale:
      return BUTTON_CLASS.GRAYSCALE;
    default:
      return BUTTON_CLASS.TRANSPARENT;
  }
};
